<template>
  <div class="px1">
    <h3 class="font-size-4 mt0">Impact distribution</h3>
    <lw-radar-chart
      v-if="redFlagDistribution"
      :chart-data="redFlagDistribution"
      :title="''"
      :grid-colour="'#CCCBC8'"
      :text-colour="'#231F20'"
    />
  </div>
</template>

<script>
import RadarChart from '../livewires/RadarChart'

export default {
  components: {
    lwRadarChart: RadarChart
  },
  props: {
    page: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      flags: []
    }
  },
  computed: {
    redFlagDistribution () {
      return this.$store.getters.redFlagDistribution(this.page)
    }
  }
}
</script>
